import React from "react";
import { X } from "lucide-react";

export default function FilterPills({ filters, setFilters, clearAll, filterOptions = {} }) {
  const filterLabels = {
    brand: "Brand",
    region: "Region",
    campaign: "Campaign",
    poc_name: "POC Name",
    key_account: "Key Account"
  };

  // Helper to get label from filterOptions with null checks
  const getLabel = (key, value) => {
    if (!value) return '';
    const optionsKey = key === 'campaign' ? 'campaign_names' : key + 's'; // handle pluralization and campaign_names
    const options = filterOptions?.[optionsKey] || [];
    const found = options.find(opt => opt.value === value);
    return found ? found.label : value;
  };

  // Only show pills for non-empty filters
  const pills = [];
  
  // Handle single-value filters (brand, region, key_account)
  Object.entries(filterLabels).forEach(([key, label]) => {
    if (key === 'campaign' || key === 'poc_name') {
      // Handle multi-select filters
      if (Array.isArray(filters[key]) && filters[key].length > 0) {
        filters[key].forEach((value) => {
          if (value) {
            pills.push(
              <span key={`${key}_${value}`} className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full flex items-center gap-1">
                {label}: {getLabel(key, value)}
                <X className="h-4 w-4 cursor-pointer" onClick={() => setFilters(p => ({ ...p, [key]: p[key].filter(v => v !== value) }))} />
              </span>
            );
          }
        });
      }
    } else {
      // Handle single-value filters
      if (filters[key] && filters[key] !== "") {
        pills.push(
          <span key={key} className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full flex items-center gap-1">
            {label}: {getLabel(key, filters[key])}
            <X className="h-4 w-4 cursor-pointer" onClick={() => setFilters(p => ({ ...p, [key]: "" }))} />
          </span>
        );
      }
    }
  });

  // Add pills for each selected POC ID
  if (Array.isArray(filters.poc_id) && filters.poc_id.length > 0) {
    filters.poc_id.forEach((poc) => {
      if (!poc) return; // Skip empty POC IDs
      pills.push(
        <span key={`poc_id_${poc}`} className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full flex items-center gap-1">
          POC ID: {getLabel('poc_id', poc)}
          <X className="h-4 w-4 cursor-pointer" onClick={() => setFilters(p => ({ ...p, poc_id: p.poc_id.filter(id => id !== poc) }))} />
        </span>
      );
    });
  } else if (filters.poc_id && typeof filters.poc_id === 'string' && filters.poc_id !== "") {
    pills.push(
      <span key={`poc_id_${filters.poc_id}`} className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full flex items-center gap-1">
        POC ID: {getLabel('poc_id', filters.poc_id)}
        <X className="h-4 w-4 cursor-pointer" onClick={() => setFilters(p => ({ ...p, poc_id: "" }))} />
      </span>
    );
  }

  // Date range pill
  if (filters.start_date && filters.end_date) {
    pills.push(
      <span key="date" className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full flex items-center gap-1">
        Date: {filters.start_date} to {filters.end_date}
        <X className="h-4 w-4 cursor-pointer" onClick={() => setFilters(p => ({ ...p, start_date: "", end_date: "" }))} />
      </span>
    );
  }

  return (
    <div className="flex flex-wrap items-center gap-2 mb-6">
      {pills}
      {(pills.length > 0) && (
        <button onClick={clearAll} className="ml-2 text-sm text-blue-600 hover:underline">
          Clear All
        </button>
      )}
    </div>
  );
} 